export default "__VITE_ASSET__BomekY1e__"